import { fetchWithAuth } from './client';

interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
}

export interface Market {
  id: string;
  question: string;
  conditionId: string;
  slug: string;
  volume?: number;
  clobTokenIds?: string;
  bestAsk?: number;
  bestBid?: number;
  endDate?: string;
  negRisk?: boolean;
  outcomes?: string;
}

export interface OrderBookEntry {
  price: string;
  size: string;
  total?: number;
}

export interface OrderBook {
  bids: OrderBookEntry[];
  asks: OrderBookEntry[];
}

export const polymarketApi = {
  searchEvents: (query: string) =>
    fetchWithAuth<ApiResponse<Market[]>>(`/polymarket/events?q=${encodeURIComponent(query)}`),

  getOrderBook: (tokenId: string) => fetchWithAuth<ApiResponse<OrderBook>>(`/polymarket/orderbook/${tokenId}`),

  placeOrder: (data: {
    tokenId: string;
    side: 'BUY' | 'SELL';
    size: number;
    price: number;
    negRisk?: boolean;
    question?: string;
    outcome?: string;
  }) =>
    fetchWithAuth<ApiResponse<unknown>>('/polymarket/order', {
      method: 'POST',
      body: JSON.stringify(data)
    })
};
